(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('TaskObjectType', TaskObjectType);

    TaskObjectType.$inject = ['$resource'];

    function TaskObjectType ($resource) {
        var resourceUrl =  'api/task-object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
